import { Stack } from '@mui/system';
import { Sendpulse } from '../../components';

export const MenuPaperLayout = ({
  children,
  sendpulseId,
  fixed,
}: {
  children: React.ReactNode;
  sendpulseId?: string;
  fixed?: boolean;
}) => {
  return (
    <Stack
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        width: '100%',
        maxHeight: fixed ? { xs: 'calc(100dvh - 3rem)', lg: '100vh' } : 'auto',
        overflow: 'hidden',
      }}
    >
      {sendpulseId && <Sendpulse id={sendpulseId} />}
      <Stack
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          width: '100%',
          height: '100%',
          gap: 2,
          p: { xs: 0, md: 1, lg: 2, xl: 4 },
          pt: { xs: 2 },
        }}
      >
        {children}
      </Stack>
    </Stack>
  );
};
